module.exports = __webpack_public_path__ + "static/media/facebook.14feef9e.svg";